import { createRouter, createWebHistory } from 'vue-router';
import routes from "@/router/routes";
import authService from "@/service/authService";
import { cancelPendingRequests } from "@/service/providers/axios";

const router = createRouter({
    history: createWebHistory(),
    routes
});


router.beforeEach((to, from, next) => {
    const isSameRoute = to.path === from.path && to.name === from.name;
    if (!isSameRoute) {
        cancelPendingRequests();
    }
    if (to.meta.requiresAuth) {
        const token = localStorage.getItem('authToken');
        if (token) {
            next();
        } else {
            next('/login');
        }
    } else if (to.name === 'Login') {
        const token = localStorage.getItem('authToken');

        if (token) {
            next('/');
        } else {
            next();
        }
    } else {
        const clientTokenResponse = authService.clientToken();

        clientTokenResponse.then((response) => {
            const clientToken = response.data.data.access_token;
            localStorage.setItem('clientToken', clientToken);
        });

        next();
    }
});

export default router;
